import React from 'react';
import { motion } from 'framer-motion';
import NewChatHeader from './NewChatHeader';
import NewMessageList from './NewMessageList';
import NewInputBar from './NewInputBar';

interface NewChatWindowProps {
  messages: any[];
  selectedChat: any;
  onSendMessage: (message: string, attachments: any) => void;
  chatId: string;
  isLoading: boolean;
  loadMoreMessages: () => void;
  hasMore: boolean;
  isFetchingMore: boolean;
  page: number;
  uploadingImages: boolean;
  isTyping: boolean;
  onOpenGallery: () => void;
  handleStartCall: (val: boolean) => void;
  onBack: () => void;
  setShowChatList: (show: boolean) => void;
  showChatList: boolean;
  chatList: any[];
  userMap: Record<string, any>;
  onMessagesRead: (messageIds: string[]) => void;
  onReply: (messageId: string) => void;
  replyToId: string | null;
  clearReply: () => void;
  onTyping: () => void;
}

const NewChatWindow: React.FC<NewChatWindowProps> = ({
  messages,
  selectedChat,
  onSendMessage,
  chatId,
  isLoading,
  loadMoreMessages,
  hasMore,
  isFetchingMore,
  page,
  uploadingImages,
  isTyping,
  onOpenGallery,
  handleStartCall,
  onBack,
  setShowChatList,
  showChatList,
  chatList,
  userMap,
  onMessagesRead,
  onReply,
  replyToId,
  clearReply,
  onTyping: onTypingProp,
}) => {
  return (
    <motion.div
      transition={{ duration: 0.3 }}
      className="flex flex-col h-full w-full overflow-hidden"
    >
      <NewChatHeader
        selectedChat={selectedChat}
        onOpenGallery={onOpenGallery}
        handleStartCall={handleStartCall}
        onBack={onBack}
        setShowChatList={setShowChatList}
        showChatList={showChatList}
        chatList={chatList}
      />
      <NewMessageList
        messages={messages}
        selectedChat={selectedChat}
        isLoading={isLoading}
        loadMoreMessages={loadMoreMessages}
        hasMore={hasMore}
        page={page}
        isTyping={isTyping}
        userMap={userMap}
        onMessagesRead={onMessagesRead}
        onReply={onReply}
      />
      <div className="flex-shrink-0">
        <NewInputBar
          onSendMessage={onSendMessage}
          uploadingImages={uploadingImages}
          chatId={chatId}
          selectedChat={selectedChat}
          replyToId={replyToId}
          clearReply={clearReply}
          messages={messages}
          userMap={userMap}
          onTyping={onTypingProp}
        />
      </div>
    </motion.div>
  );
};

export default NewChatWindow;
